export class LOGINUSERTRACK {
    userLoginId: string;
    roleId: number;
}
